import { createContext, useContext, useMemo, useRef } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { getFeaturesDemo, updateFeaturesDemo } from "../../api/home";

import { generatePayload, getIntialValues } from "./helper";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const trainersArrayRef = useRef();
  const believesArrayRef = useRef();
  const monialsRef = useRef();
  const toaster = useToaster();

  const getFeaturesDemoQuery = useQuery({
    queryKey: [""],
    queryFn: getFeaturesDemo,
  });

  const updateFeaturesDemoQuery = useMutation({ mutationFn: updateFeaturesDemo });

  const initialValues = useMemo(() => {
    const homeData = getFeaturesDemoQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getFeaturesDemoQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getFeaturesDemoQuery?.data?.data?.data?.[0] || {};

    updateFeaturesDemoQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getFeaturesDemoQuery.refetch();
        },
      },
    );
    return;
  };

  const handleTrainerAdd = () => {
    trainersArrayRef.current?.push({
      title: "",
      video_url: "",
      image_link: "",
    });
  };
  const handleTrainerDelete = (index) => () => {
    trainersArrayRef.current?.remove(index);
  };

  const handleBeliefAdd = () => {
    believesArrayRef.current?.push({
      image_link: "",
      label: "",
      description: "",
    });
  };

  const handleBeliefDelete = (index) => () => {
    believesArrayRef.current?.remove(index);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,

        handleTrainerAdd,
        handleTrainerDelete,
        trainersArrayRef,
        believesArrayRef,
        handleBeliefAdd,
        handleBeliefDelete,
        monialsRef,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageProvider = () => {
  return useContext(PageContext);
};
